import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Problems} from "../../../../types/problemsSchema";


interface ProblemsState {
    loading: boolean;
    error: string | null;
    data: Problems;
}

const initialState: ProblemsState = {
    loading: false,
    error: null,
    data: {} as Problems,
};

const problemsSlice = createSlice({
    name: 'problems',
    initialState,
    reducers: {
        problemsRequested: (state) => {
            state.loading = true;
            state.error = null;
        },
        problemsReceived: (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        },
        problemsRequestFailed: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    problemsRequested,
    problemsReceived,
    problemsRequestFailed,
} = problemsSlice.actions;

export const problemsReducer = problemsSlice.reducer;